/**
 * Mốc của khoảng "Tuỳ chọn" — chuỗi người dùng chọn → mốc tuyệt đối (ms).
 *
 * Hai dạng cùng được nhận, vì cả hai đều có mặt thật:
 *   • `YYYY-MM-DDTHH:mm` — ô chọn ngày giờ (`ChonKhoangGio`), giờ ĐỊA PHƯƠNG;
 *   • `YYYY-MM-DD` — liên kết cũ từ trang Tổng quan và URL đã lưu trước khi có giờ.
 *
 * Mốc trên là MỐC MỞ (`den` không bao gồm, cùng hợp đồng audit-service). Người chọn
 * "đến 17:30" nghĩa là cả phút 17:30 được tính, nên mốc gửi đi là 17:31; một NGÀY
 * trần nghĩa là cả ngày ấy, nên mốc gửi đi là 00:00 hôm sau — đúng hành vi cũ.
 */

const MOT_PHUT = 60_000;
const MOT_NGAY = 86_400_000;

function coGio(chuoi: string): boolean {
  return chuoi.includes('T');
}

/** Mốc dưới (bao gồm). `NaN` khi chuỗi hỏng — nơi gọi tự quyết cách lùi. */
export function mocDau(chuoi: string): number {
  // Chuỗi ISO không múi giờ được `Date` đọc thành giờ địa phương (ECMA-262 §21.4.3.2).
  return new Date(coGio(chuoi) ? chuoi : `${chuoi}T00:00:00`).getTime();
}

/** Mốc trên (KHÔNG bao gồm). */
export function mocCuoi(chuoi: string): number {
  if (coGio(chuoi)) return new Date(chuoi).getTime() + MOT_PHUT;
  return new Date(`${chuoi}T00:00:00`).getTime() + MOT_NGAY;
}
